import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css.global`
  .claim-image-add-contents {
    width: 420px;
    padding: 16px;
  }
  .claim-image-add-title {
    font-size: 16px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    margin-bottom: 16px;
  }
  .claim-image-add-contents .ant-upload.ant-upload-drag {
    background: #fafafa;
  }
  .claim-image-add-contents .claim-image-file-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    padding: 6px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background: #fafafa;
    font-size: 13px;
  }
  .claim-image-add-contents .claim-image-file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 8px;
  }
  .claim-image-add-contents .claim-image-file-remove {
    cursor: pointer;
    color: #888;
    font-size: 12px;
    padding: 0 6px;
  }
  .claim-image-add-contents :global(.submit-button) {
    margin-top: 16px;
    ${common.button}
    ${common.submitButton}
  }
  .claim-image-add-contents :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
